import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: '',
    avatar: ''
  }
})

export default {
  [types.SET_GUEST] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.guest = payload
  },
  [types.SET_GUESTS] (state, payload) {
    state.guests = payload.data
    state.pagination = payload.meta.pagination
  }
}
